/**
 *   Generated file. Do not edit
 */

import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getAddress: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/ble/address',
    path: '/1024//22',
    responseBodyDecoder: allConverters.stringMacaddress,
  } as ServiceCallType<void, string>,
};
